'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var FailureAuditLogService = function FailureAuditLogService(restangular) {
  var failureAuditLogService = restangular.service('domain/faresoptimizer/failureAuditLog');
  function sendRequest(requestParams) {
    failureAuditLogService.post(requestParams).then(function () {
      toastr.info("Please view the Failure Audit Log file from the designated location that was configured during system implementation.");
    })["catch"](function () {
      $log.error('Failure audit log : request failed.');
      toastr.error('Failure Audit Log request failed.');
    });
  }
  return {
    sendRequest: sendRequest
  };
};
FailureAuditLogService.$inject = ['Restangular'];
module.exports = FailureAuditLogService;